import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";

import Style from "@client/utils/Style";

const getInputWidth = (props: any) => {
  if (props.width) {
    return props.width;
  }

  if (props.large) {
    return `${Style.inputSizes.large.width}px`;
  }

  return `${Style.inputSizes.regular.width}px`;
};

const Input = styled.textarea`
  width: ${(props: any) => getInputWidth(props)};
  height: ${(props: any) =>
    props.height || `${Style.inputSizes.regular.height * 2}px`};
  border-radius: ${Style.borderRadius};
  background-color: ${(props: any) =>
    props.readOnly ? Style.palette.grayscale[1] : "#FFF"};
  border: 1px solid
    ${(props: any) =>
      props.highlight
        ? Style.palette.alert
        : props.readOnly
          ? "transparent"
          : Style.palette.grayscale[3]};
  color: ${Style.palette.black};
  padding: 8px;
  font-size: inherit;
  transition: all ${Style.animations.swift};
  box-sizing: border-box;
  font-family: monospace;
  resize: none;
  &:hover {
    border-color: ${(props: any) =>
      props.highlight
        ? Style.palette.alert
        : props.readOnly
          ? ""
          : Style.palette.primaryHighlight};
  }
  &:focus {
    border-color: ${(props: any) =>
      props.highlight
        ? Style.palette.alert
        : props.readOnly
          ? ""
          : Style.palette.primaryHighlight};
    outline: none;
  }
  &:disabled {
    color: ${Style.palette.grayscale[3]};
    border-color: ${Style.palette.grayscale[0]};
    background-color: ${Style.palette.grayscale[0]};
  }
  &::placeholder {
    color: ${Style.palette.grayscale[3]};
  }
`;
@observer
class TextArea extends React.Component<any> {
  render() {
    return (
      <Input
        {...this.props}
        ref={r => {
          if (this.props.customRef) {
            this.props.customRef(r);
          }
        }}
      />
    );
  }
}

export default TextArea;
